import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {FixtureCreatedEvent} from './fixtures.types';

@Injectable({providedIn: 'root'})
export class FixturesEventsService {
  private readonly createdSubject = new Subject<FixtureCreatedEvent>();
  readonly created$ = this.createdSubject.asObservable();

  notifyCreated(event: FixtureCreatedEvent): void {
    this.createdSubject.next(event);
  }
}
